import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withCookies } from 'react-cookie';
import Globals from '../../../Globals';
import FichaCliente from './fichaCliente';
import ContractsService from '../../../services/ContractsService';
import '../../css/huerto/scoringTable.css';
import TablaVencimientos from './componentScoringTable/tablaVencimientos';
import ScoringFilters from './componentScoringTable/scoringFilter';
import Loading from '../../bronson/Loading';
import DetalleContratoTableVencimiento from './componentScoringTable/detalleContratoTableVencimiento';
import FilterVencimientosAsignados from './componentScoringTable/filterVencimientosAsignados';
import DistribucionAsignacionJJVV from './componentScoringTable/componentAsignacion/distribucionAsignacionJJVV';
import usePermissions from 'hooks/usePermissions';
import FunctionGeneral from '../scoring/functionsGeneral'; // agregar crear tabla en funcion general para mañana es tarde!, hacer un modal para los filtros parecido a la descarga de metricas, se usa en muchos lugares
import FichaCancelacionCliente from './fichaCancelacionCliente';
import FichaClienteLPO from './fichaClienteLPO';

function ScoringTable(props) {
    const [dataTodosLosVencimientos, setDataTodosLosVencimientos] = useState(
        props.dataTodosLosVencimientos
    );
    const [dataVencimientosAsignados, setDataVencimientosAsignados] = useState(
        props.dataVencimientosAsignados
    );
    const [fichaCliente, setfichaCliente] = useState(false);
    const [fichaClienteLPO, setfichaClienteLPO] = useState(false);
    const [fichaCancelacionCliente, setFichaCancelacionCliente] = useState(
        false
    );
    const [
        viewdistribucionAsignacion,
        setViewdistribucionAsignacion,
    ] = useState(false);
    const [loading, setLoading] = useState(false);
    const [
        viewDataVencimientoAsignado,
        setViewDataVencimientoAsignado,
    ] = useState(props.user.data.Profile === 12 ? false : true);
    const [dataCliente, setdataCliente] = useState([]);
    const [dataVehiculo, setdataVehiculo] = useState([]);
    const [dataContrato, setdataContrato] = useState([]);
    const [dataEconomical, setdataEconomical] = useState([]);
    const [dataDecisions, setdataDecisions] = useState([]);
    const [dataVinculacion, setdataVinculacion] = useState([]);
    const [dataListTypeDecisions, setdataListTypeDecisions] = useState([]);
    const [UUID_ActionsActividad, setUUID_ActionsActividad] = useState('');
    const [dataProyeccion, setdataProyeccion] = useState([]);
    const [dataSimulacion, setdataSimulacion] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setrowsPerPage] = useState(15);
    const [indiceRow, setIndiceRow] = useState(-1);
    const [IndiceRowDetalle, setIndiceRowDetalle] = useState(-1);
    const [listSelectVencimiento, setListSelectVencimiento] = useState([]);
    const [
        listPerfilesAsignacionVolumenVendedor,
        setlistPerfilesAsignacionVolumenVendedor,
    ] = useState([]);
    const [filtermatriculAsignados, setFiltermatriculAsignados] = useState('');
    const [filterAsignados, setFilterAsignados] = useState(0);
    const [resetperPag, setresetperPag] = useState(true);
    const [orden, setOrden] = useState([]);
    const [
        diasAlertaVencimientoToProducto,
        setDiasAlertaVencimientoToProducto,
    ] = useState(setDiasAlertaVencimientoProducto);
    const { checkPermission } = usePermissions();
    const [financialOperationCode, setFinancialOperationCode] = useState('');
    const [financialOperationCodeLPO, setFinancialOperationCodeLPO] = useState(
        ''
    );
    const [financialOperationCodeLPA, setFinancialOperationCodeLPA] = useState(
        ''
    );

    useEffect(() => {
        if (fichaCliente || fichaCancelacionCliente || fichaClienteLPO) {
            document.getElementById('SelectConce').style.display = 'none';
            props.setTitleText();
        } else {
            if (viewDataVencimientoAsignado)
                props.setTitleText(
                    'Listado completo de vencimientos (' +
                        props.dataTodosLosVencimientos.length +
                        ')'
                );
            else {
                props.setTitleText(
                    'Tus vencimientos asignados (' +
                        props.dataVencimientosAsignados.length +
                        ')'
                );
            }
            document.getElementById('SelectConce').style.display = '';
        }
    }, [fichaCliente, fichaCancelacionCliente, fichaClienteLPO]);

    useEffect(() => {
        setPage(0);
        setIndiceRow(-1);
        setIndiceRowDetalle(-1);
        var newDataVencimientosAsignados = [];
        props.dataVencimientosAsignados.forEach(element => {
            if (
                element.VehiclePlate !== null &&
                element.VehiclePlate !== '' &&
                filtermatriculAsignados.length <= element.VehiclePlate.length
            )
                if (
                    element.VehiclePlate.match(
                        filtermatriculAsignados.toUpperCase()
                    )
                )
                    newDataVencimientosAsignados.push(element);
        });
        setDataVencimientosAsignados(newDataVencimientosAsignados);
    }, [filtermatriculAsignados]);

    useEffect(() => {
        setPage(0);
        if (filterAsignados === 0)
            setDataTodosLosVencimientos(props.dataTodosLosVencimientos);
        else if (filterAsignados === 1) {
            var new_dataTodosLosVencimientos = [];
            props.dataTodosLosVencimientos.forEach(element => {
                if (element.VendedorAsignado !== null)
                    new_dataTodosLosVencimientos.push(element);
            });
            setDataTodosLosVencimientos(new_dataTodosLosVencimientos);
        } else if (filterAsignados === 2) {
            var new_dataTodosLosVencimientos = [];
            props.dataTodosLosVencimientos.forEach(element => {
                if (element.VendedorAsignado === null)
                    new_dataTodosLosVencimientos.push(element);
            });
            setDataTodosLosVencimientos(new_dataTodosLosVencimientos);
        }
    }, [filterAsignados]);

    useEffect(() => {
        setListSelectVencimiento([]);
        if (viewDataVencimientoAsignado) {
            props.setTitleText(
                'Listado completo de vencimientos (' +
                    props.dataTodosLosVencimientos.length +
                    ')'
            );
            document.getElementById('DistribucionAsignados').style.display =
                'inline-grid';
        } else {
            document.getElementById('DistribucionAsignados').style.display =
                'none';
            props.setTitleText(
                'Tus vencimientos asignados (' +
                    props.dataVencimientosAsignados.length +
                    ')'
            );
            setFiltermatriculAsignados('');
        }
        setOrden([]);
        setPage(0);
        setIndiceRow(-1);
        setIndiceRowDetalle(-1);
        setViewdistribucionAsignacion(false);
    }, [viewDataVencimientoAsignado]);

    useEffect(() => {
        if (resetperPag) {
            setIndiceRow(-1);
            setPage(0);
            setIndiceRowDetalle(-1);
        }
        setDataVencimientosAsignados(props.dataVencimientosAsignados);
        if (!viewDataVencimientoAsignado)
            props.setTitleText(
                'Tus vencimientos asignados (' +
                    props.dataVencimientosAsignados.length +
                    ')'
            );
    }, [props.dataVencimientosAsignados]);

    useEffect(() => {
        setListSelectVencimiento([]);
        if (resetperPag) {
            setFilterAsignados(0);
            setIndiceRow(-1);
            setPage(0);
            setIndiceRowDetalle(-1);
            setDataTodosLosVencimientos(props.dataTodosLosVencimientos);
        }
        if (viewDataVencimientoAsignado)
            props.setTitleText(
                'Listado completo de vencimientos (' +
                    props.dataTodosLosVencimientos.length +
                    ')'
            );
    }, [props.dataTodosLosVencimientos]);

    useEffect(() => {
        readListPerfilesAsignacionVolumenVendedor(props.dealerCodeVWF);
    }, [props.dealerCodeVWF]);

    useEffect(() => {
        var listaVencimiento = viewDataVencimientoAsignado
            ? dataTodosLosVencimientos
            : dataVencimientosAsignados;

        if (indiceRow >= 0) {
            getUUIDDecisionesService();
            setDataSimulaciones(
                listaVencimiento[indiceRow].FinancialOperationCode
            );
            getInformationVehiclesEconomical(
                listaVencimiento[indiceRow].FinancialOperationCode
            );
            getdataClienteList(
                listaVencimiento[indiceRow].FinancialOperationCode
            );
            getactionsDecisionsList(
                listaVencimiento[indiceRow].FinancialOperationCode
            );
            getactionsDecisionstypeList(
                listaVencimiento[indiceRow].ProductBoxId
            );
            getdataContract(listaVencimiento[indiceRow].FinancialOperationCode);
            getdataBoding(listaVencimiento[indiceRow].FinancialOperationCode);
            getdataVehicleContract(
                listaVencimiento[indiceRow].FinancialOperationCode
            );
            getdataProyeccion(
                listaVencimiento[indiceRow].FinancialOperationCode,
                props.dealerCodeVWF,
                listaVencimiento[indiceRow].ProductBoxId,
                listaVencimiento[indiceRow].IPODate
            );
            setfichaCliente(true);
            setLoading(true);
        }
    }, [indiceRow]);

    useEffect(() => {
        if (financialOperationCode != '') {
            setDataSimulaciones(financialOperationCode);
            getInformationVehiclesEconomical(financialOperationCode);
            getdataClienteList(financialOperationCode);
            getdataContract(financialOperationCode);
            getdataBoding(financialOperationCode);
            getdataVehicleContract(financialOperationCode);
            setFichaCancelacionCliente(true);
            setLoading(true);
        }
    }, [financialOperationCode]);

    useEffect(() => {
        if (financialOperationCodeLPO != '') {
            getdataClienteList(financialOperationCodeLPO);
            getdataContract(financialOperationCodeLPO);
            getdataVehicleContract(financialOperationCodeLPO);
            setfichaClienteLPO(true);
            setLoading(true);
        }
    }, [financialOperationCodeLPO]);

    useEffect(() => {
        window.bronson.ComponentRegister.initAll();
    }, []);

    //inicio de servicios
    function setIndiceRowResetState() {
        setdataSimulacion([]);
        setdataEconomical([]);
        setdataCliente([]);
        setdataDecisions([]);
        setdataContrato([]);
        setdataVinculacion([]);
        setdataVehiculo([]);
        setdataProyeccion([]);
    }
    async function setDataSimulaciones() {
        var _FinancialOperationCode = viewDataVencimientoAsignado
            ? dataTodosLosVencimientos
            : dataVencimientosAsignados;
        var operationCode =
            financialOperationCode != ''
                ? financialOperationCode
                : financialOperationCodeLPO != ''
                    ? financialOperationCodeLPO
                    : _FinancialOperationCode?.[indiceRow]
                        ?.FinancialOperationCode;
        if (!operationCode) return;

        var _dataSimulacion = await new ContractsService().listSimulacionLPA(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            operationCode
        );
        if (
            _dataSimulacion &&
            _dataSimulacion.statusCode === 200 &&
            _dataSimulacion.body &&
            _dataSimulacion.body.Result
        ) {
            var dataSimulacion = JSON.parse(_dataSimulacion.body.Result);
            setdataSimulacion(dataSimulacion);
        }
    }
    async function readListPerfilesAsignacionVolumenVendedor(dealerCodeVWF) {
        var _response = await new ContractsService().readListPerfilesAsignacionVolumenVendedor(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            dealerCodeVWF
        );
        if (
            _response &&
            _response.statusCode === 200 &&
            _response.body &&
            _response.body.Result
        ) {
            var response = JSON.parse(_response.body.Result);
            setlistPerfilesAsignacionVolumenVendedor(response);
        }
    }
    async function getInformationVehiclesEconomical(FinancialOperationCode) {
        var _InformationVehiclesEconomical = await new ContractsService().readInformationVehiclesEconomical(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            props.cookies.get(Globals.COOKIES.USER),
            FinancialOperationCode
        );
        if (
            _InformationVehiclesEconomical &&
            _InformationVehiclesEconomical.statusCode === 200 &&
            _InformationVehiclesEconomical.body &&
            _InformationVehiclesEconomical.body.Result
        ) {
            var InformationVehiclesEconomical_ = JSON.parse(
                _InformationVehiclesEconomical.body.Result
            );
            setdataEconomical(InformationVehiclesEconomical_);
        }
    }
    async function getUUIDDecisionesService() {
        var _UUID = await new ContractsService().readUUIDDecisionesService(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken
        );
        if (
            _UUID &&
            _UUID.statusCode === 200 &&
            _UUID.body &&
            _UUID.body.Result
        ) {
            var UUID = _UUID.body;
            setUUID_ActionsActividad(UUID.Result);
        }
    }
    async function getactionsDecisionstypeList(tipoProducto) {
        var _dataDecisionstypeList = await new ContractsService().readActionsDecisionstypeList(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            props.cookies.get(Globals.COOKIES.USER),
            tipoProducto === '132 ' ? true : false
        );
        if (
            _dataDecisionstypeList &&
            _dataDecisionstypeList.statusCode === 200 &&
            _dataDecisionstypeList.body &&
            _dataDecisionstypeList.body.Result
        ) {
            var _dataDecisionstypeList = JSON.parse(
                _dataDecisionstypeList.body.Result
            );
            if (
                JSON.stringify(dataListTypeDecisions) !==
                JSON.stringify(_dataDecisionstypeList)
            )
                setdataListTypeDecisions(_dataDecisionstypeList);
        }
    }
    async function getactionsDecisionsList(FinancialOperationCode) {
        var dataDecisionsList = await new ContractsService().readActionsDecisionsList(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            props.cookies.get(Globals.COOKIES.USER),
            FinancialOperationCode
        );
        if (
            dataDecisionsList &&
            dataDecisionsList.statusCode === 200 &&
            dataDecisionsList.body &&
            dataDecisionsList.body.Result
        ) {
            var _dataDecisionsList = JSON.parse(dataDecisionsList.body.Result);
            if (
                JSON.stringify(dataDecisions) !==
                JSON.stringify(_dataDecisionsList)
            )
                setdataDecisions(_dataDecisionsList);
        }
    }
    async function getdataClienteList(FinancialOperationCode) {
        var dataClienteList = await new ContractsService().readServiceClient(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            props.cookies.get(Globals.COOKIES.USER),
            FinancialOperationCode
        );
        if (
            dataClienteList &&
            dataClienteList.statusCode === 200 &&
            dataClienteList.body &&
            dataClienteList.body.Result
        ) {
            var _dataClienteList = JSON.parse(dataClienteList.body.Result);
            if (
                JSON.stringify(dataCliente) !== JSON.stringify(_dataClienteList)
            ) {
                setdataCliente(_dataClienteList);
            }
        }
    }
    async function getdataContract(idDataContract) {
        var dataContract = await new ContractsService().readServiceContract(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            props.cookies.get(Globals.COOKIES.USER),
            idDataContract
        );
        if (
            dataContract &&
            dataContract.statusCode === 200 &&
            dataContract.body &&
            dataContract.body.Result
        ) {
            var _dataContract = JSON.parse(dataContract.body.Result);
            if (JSON.stringify(dataContract) !== JSON.stringify(_dataContract))
                setdataContrato(_dataContract);
        }
    }
    async function getdataBoding(FinancialOperationCode) {
        var dataBoding = await new ContractsService().readInformationBonding(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            props.cookies.get(Globals.COOKIES.USER),
            FinancialOperationCode
        );
        if (
            dataBoding &&
            dataBoding.statusCode === 200 &&
            dataBoding.body &&
            dataBoding.body.Result
        ) {
            var _getdataBoding = JSON.parse(dataBoding.body.Result);
            if (
                JSON.stringify(dataVinculacion) !==
                JSON.stringify(_getdataBoding)
            )
                setdataVinculacion(_getdataBoding);
        }
    }
    async function getdataVehicleContract(FinancialOperationCode) {
        var _dataContract = await new ContractsService().readVehicleContract(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            props.cookies.get(Globals.COOKIES.USER),
            FinancialOperationCode
        );
        if (
            _dataContract &&
            _dataContract.statusCode === 200 &&
            _dataContract.body &&
            _dataContract.body.Result
        ) {
            var _dataContract = JSON.parse(_dataContract.body.Result);
            if (JSON.stringify(dataContrato) !== JSON.stringify(_dataContract))
                setdataVehiculo(_dataContract);
        }
    }
    async function getdataProyeccion(
        FinancialOperationCode,
        DeealerCodeVWFS,
        ProductBoxId,
        IPODate
    ) {
        var typeContrato = false;
        if (ProductBoxId === '158 ') typeContrato = true;
        var dataProyeccion_ = await new ContractsService().readInformationProyeccion(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            props.cookies.get(Globals.COOKIES.USER),
            FinancialOperationCode,
            DeealerCodeVWFS,
            typeContrato,
            IPODate
        );
        if (
            dataProyeccion_ &&
            dataProyeccion_.statusCode === 200 &&
            dataProyeccion_.body &&
            dataProyeccion_.body.Result
        ) {
            var _dataProyeccion = JSON.parse(dataProyeccion_.body.Result);
            if (
                JSON.stringify(dataProyeccion) !==
                JSON.stringify(_dataProyeccion)
            )
                setdataProyeccion(_dataProyeccion);
        }
    }
    async function aplicarAsignacionVencimiento(userAsignacion) {
        var _response = await new ContractsService().AsignacionVolumenVendedor(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            props.user.data.UserId,
            listSelectVencimiento,
            userAsignacion,
            props.dealerCodeVWF,
            checkPermission('CNST_ASIGNACION_VOLUMEN_VENDEDOR') ? 'R' : 'A'
            //dkxewh5
        );
        setresetperPag(false);

        if (
            _response &&
            _response.statusCode === 200 &&
            _response.body &&
            _response.body.Result
        ) {
            var response = JSON.parse(_response.body.Result);
            var newListVencimientos = JSON.parse(
                JSON.stringify(dataTodosLosVencimientos)
            );
            var newListVencimientosInicial = JSON.parse(
                JSON.stringify(props.dataTodosLosVencimientos)
            );

            var nombreAsignacion = '';
            for (
                let i = 0;
                i < listPerfilesAsignacionVolumenVendedor.length;
                i++
            )
                if (
                    listPerfilesAsignacionVolumenVendedor[i].IDEMPLEADO ===
                    userAsignacion
                ) {
                    nombreAsignacion =
                        listPerfilesAsignacionVolumenVendedor[i].NOMBRE;
                    break;
                }

            newListVencimientos.forEach(element => {
                if (
                    listSelectVencimiento.includes(
                        element.FinancialOperationCode
                    )
                ) {
                    element.Fravorito = 0;
                    element.VendedorAsignado = nombreAsignacion;
                }
            });
            newListVencimientosInicial.forEach(element => {
                if (
                    listSelectVencimiento.includes(
                        element.FinancialOperationCode
                    )
                ) {
                    element.Fravorito = 0;
                    element.VendedorAsignado = nombreAsignacion;
                }
            });
            props.getTableDataAsignados(
                props.dealerCodeVWF,
                userAsignacion,
                -1
            );
            props.setDataTodosLosVencimientos(newListVencimientosInicial);
            setDataTodosLosVencimientos(newListVencimientos);
            setListSelectVencimiento([]);
            setTimeout(setresetperPag(true), 1000);
        }
    }
    async function setDataFavorito(indice) {
        var _idpoliza = '';
        var _favorito = '0';
        var _dataVencimientosAsignados = JSON.parse(
            JSON.stringify(dataVencimientosAsignados)
        );
        var _dataTodosLosVencimientos = JSON.parse(
            JSON.stringify(dataTodosLosVencimientos)
        );
        setresetperPag(false);
        if (viewDataVencimientoAsignado) {
            if (_dataTodosLosVencimientos[indice].Fravorito === '1')
                _dataTodosLosVencimientos[indice].Fravorito = '0';
            else _dataTodosLosVencimientos[indice].Fravorito = '1';

            _idpoliza =
                _dataTodosLosVencimientos[indice].FinancialOperationCode;
            _favorito = _dataTodosLosVencimientos[indice].Fravorito;

            _dataVencimientosAsignados.forEach(element => {
                if (element.FinancialOperationCode === _idpoliza)
                    element.Fravorito = _favorito;
            });
        } else {
            if (_dataVencimientosAsignados[indice].Fravorito === '1')
                _dataVencimientosAsignados[indice].Fravorito = '0';
            else _dataVencimientosAsignados[indice].Fravorito = '1';

            _idpoliza =
                _dataVencimientosAsignados[indice].FinancialOperationCode;
            _favorito = _dataVencimientosAsignados[indice].Fravorito;

            _dataTodosLosVencimientos.forEach(element => {
                if (element.FinancialOperationCode === _idpoliza)
                    element.Fravorito = _favorito;
            });
        }
        props.setDataVencimientosAsignados(_dataVencimientosAsignados);
        props.setDataTodosLosVencimientos(_dataTodosLosVencimientos);
        var _response = await new ContractsService().UpdateFavoritoSelect(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            _favorito,
            _idpoliza
        );

        if (
            _response &&
            _response.statusCode === 200 &&
            _response.body &&
            _response.body.Result
        )
            var response = JSON.parse(_response.body.Result);
        setTimeout(setresetperPag(true), 1000);
    }
    async function setDiasAlertaVencimientoProducto() {
        var _response = await new ContractsService().ReadDiasAlertaVencimientoToProducto(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken
        );
        if (
            _response &&
            _response.statusCode === 200 &&
            _response.body &&
            _response.body.Result
        )
            var response = JSON.parse(_response.body.Result);
        setDiasAlertaVencimientoToProducto(response);
    }

    const getScoringFilters = () => {
        if (!fichaCliente) {
            if (viewDataVencimientoAsignado) {
                return (
                    <ScoringFilters
                        optSelectMarca={props.optSelectMarca}
                        setFiltersApplied={props.setFiltersApplied}
                        filtersApplied={props.filtersApplied}
                        dataTodosLosVencimientos={dataTodosLosVencimientos}
                        dealerCodeVWF={props.dealerCodeVWF}
                        cookies={props.cookies}
                        listSelectVencimiento={listSelectVencimiento}
                        aplicarAsignacionVencimiento={
                            aplicarAsignacionVencimiento
                        }
                        setViewDataVencimientoAsignado={
                            setViewDataVencimientoAsignado
                        }
                        listPerfilesAsignacionVolumenVendedor={
                            listPerfilesAsignacionVolumenVendedor
                        }
                        matrixData={props.matrixData}
                        matrixContracts={props.matrixContracts}
                        setMatrixContracts={props.setMatrixContracts}
                        user={props.user}
                        setFilterAsignados={setFilterAsignados}
                        filterAsignados={filterAsignados}
                        setViewdistribucionAsignacion={
                            setViewdistribucionAsignacion
                        }
                        viewdistribucionAsignacion={viewdistribucionAsignacion}
                        setOrden={setOrden}
                        orden={orden}
                        setFinancialOperationCode={setFinancialOperationCode}
                        financialOperationCode={financialOperationCode}
                        setFinancialOperationCodeLPO={
                            setFinancialOperationCodeLPO
                        }
                        financialOperationCodeLPO={financialOperationCodeLPO}
                    />
                );
            } else {
                return (
                    <FilterVencimientosAsignados
                        changeFilterMatricula={setFiltermatriculAsignados}
                        data={props.dataVencimientosAsignados}
                        setViewDataVencimientoAsignado={
                            setViewDataVencimientoAsignado
                        }
                        setOrden={setOrden}
                        orden={orden}
                        dataTodosLosVencimientos={
                            props.dataTodosLosVencimientos
                        }
                        financialOperationCode={financialOperationCode}
                    />
                );
            }
        } else {
            return <div></div>;
        }
    };
    const fichacliente = () => {
        var vendedor = viewDataVencimientoAsignado
            ? dataTodosLosVencimientos
            : dataVencimientosAsignados;
        return (
            <FichaCliente
                indiceRow={indiceRow}
                setIndiceRow={setIndiceRow}
                setLoading={setLoading}
                dataContrato={dataContrato}
                dataEconomical={dataEconomical}
                dataCliente={dataCliente}
                setdataCliente={setdataCliente}
                dataVehiculo={dataVehiculo}
                dataDecisions={dataDecisions}
                dataSimulacion={dataSimulacion}
                setdataDecisions={setdataDecisions}
                dataVencimientos={
                    viewDataVencimientoAsignado
                        ? dataTodosLosVencimientos
                        : dataVencimientosAsignados
                }
                setfichaCliente={setfichaCliente}
                dataListTypeDecisions={dataListTypeDecisions}
                dataVinculacion={dataVinculacion}
                dataProyeccion={dataProyeccion}
                UUID_ActionsActividad={UUID_ActionsActividad}
                vendedor={vendedor[indiceRow].SellerContractsFullName}
                setDataSimulacionProps={setDataSimulaciones}
                setIndiceRowResetState={setIndiceRowResetState}
            />
        );
    };

    const fichacancelacioncliente = () => {
        return (
            <FichaCancelacionCliente
                setLoading={setLoading}
                dataContrato={dataContrato}
                dataEconomical={dataEconomical}
                dataCliente={dataCliente}
                setdataCliente={setdataCliente}
                dataVehiculo={dataVehiculo}
                dataSimulacion={dataSimulacion}
                setFichaCancelacionCliente={setFichaCancelacionCliente}
                financialOperationCode={financialOperationCode}
                setFinancialOperationCode={setFinancialOperationCode}
                dataVinculacion={dataVinculacion}
                setDataSimulacionProps={setDataSimulaciones}
            />
        );
    };

    const fichaclienteLPO = () => {
        return (
            <FichaClienteLPO
                setLoading={setLoading}
                dataContrato={dataContrato}
                dataCliente={dataCliente}
                dataVehiculo={dataVehiculo}
                dataSimulacion={dataSimulacion}
                setDataSimulacionProps={setDataSimulaciones}
                financialOperationCodeLPA={financialOperationCodeLPA}
                setFinancialOperationCodeLPA={setFinancialOperationCodeLPA}
                setFichaClienteLPO={setfichaClienteLPO}
                financialOperationCodeLPO={financialOperationCodeLPO}
                setFinancialOperationCodeLPO={setFinancialOperationCodeLPO}
                dataVinculacion={dataVinculacion}
            />
        );
    };

    const renderView = () => {
        return (
            <React.Fragment>
                <Loading ariaBusy={loading}></Loading>
                {getScoringFilters()}
                {!fichaClienteLPO ? (
                    !fichaCancelacionCliente ? (
                        !fichaCliente ? (
                            <section>
                                {!viewdistribucionAsignacion ? (
                                    <div style={{ display: 'flex' }}>
                                        <div
                                            className={
                                                IndiceRowDetalle !== -1
                                                    ? 'u-10/12'
                                                    : 'u-12/12'
                                            }
                                        >
                                            <TablaVencimientos
                                                orden={orden}
                                                user={props.user}
                                                setIndiceRowDetalle={
                                                    setIndiceRowDetalle
                                                }
                                                setIndiceRow={setIndiceRow}
                                                data={
                                                    viewDataVencimientoAsignado
                                                        ? dataTodosLosVencimientos
                                                        : dataVencimientosAsignados
                                                }
                                                setData={setDataFavorito}
                                                page={page}
                                                setPage={setPage}
                                                rowsPerPage={rowsPerPage}
                                                setrowsPerPage={setrowsPerPage}
                                                setListSelectVencimiento={
                                                    setListSelectVencimiento
                                                }
                                                listSelectVencimiento={
                                                    listSelectVencimiento
                                                }
                                                viewDataVencimientoAsignado={
                                                    viewDataVencimientoAsignado
                                                }
                                                IndiceRowDetalle={
                                                    IndiceRowDetalle
                                                }
                                                filterAsignados={
                                                    filterAsignados
                                                }
                                                filtermatriculAsignados={
                                                    filtermatriculAsignados
                                                }
                                                onExportExcel={
                                                    props.onExportExcel
                                                }
                                                diasAlertaVencimientoToProducto={
                                                    diasAlertaVencimientoToProducto
                                                }
                                            />
                                        </div>
                                        {IndiceRowDetalle !== -1 && (
                                            <div className="u-2/12">
                                                <DetalleContratoTableVencimiento
                                                    data={
                                                        viewDataVencimientoAsignado
                                                            ? dataTodosLosVencimientos
                                                            : dataVencimientosAsignados
                                                    }
                                                    IndiceRowDetalle={
                                                        IndiceRowDetalle
                                                    }
                                                    setIndiceRowDetalle={
                                                        setIndiceRowDetalle
                                                    }
                                                    setIndiceRow={setIndiceRow}
                                                />
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div>
                                        <DistribucionAsignacionJJVV
                                            DealerCodeVWFS={props.dealerCodeVWF}
                                            cookies={props.cookies}
                                        />
                                    </div>
                                )}
                            </section>
                        ) : (
                            fichacliente()
                        )
                    ) : (
                        fichacancelacioncliente()
                    )
                ) : (
                    fichaclienteLPO()
                )}
            </React.Fragment>
        );
    };

    return renderView();

    //fin de render
}

export default withCookies(withRouter(ScoringTable));
